import { defineStore } from 'pinia'
import { ref, computed, watch, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import adminApi from '../server/seller/admin'

export const useSystemStore = defineStore(
  'system',
  () => {
    const commissionConfig = ref({});
    const pageType = ref('')
    const isAcc=ref(true)
    const programConfig = ref(
      [
        { key: '0', label: 'Attribution', disabled: false  },
        { key: '1', label: 'Associate', disabled: false },
        // { key: '2', label: 'Creator Connections', disabled: false },
      ]
    );
    const programConfigLink=ref(
      [
        {
          label: 'Attribution Link',
          key: '0',
      },
      {
          label: 'Associate Link',
          key: '1',
      },
      ]
    )
    const setProgramConfig= (obj=[])=>{
      programConfig.value=obj;
    }
    const setIsAcc=(status)=>{
      isAcc.value=status
    }
    const setProgramConfigLink= (obj=[])=>{
      programConfigLink.value=obj;
    }
    const getCommissionConfig= ()=>{
      adminApi.getCommissionConfig().then(res=>{
        commissionConfig.value=res.data
      })
    }
    const setPageType=(type)=>{
      pageType.value=type
      if(type=='seller'){
        getCommissionConfig();
      }
    }

    const brandUpdateBtn = ref(false);
    const productUpdateBtn = ref(false);
    const setBtnStatus=(type,status,activeTab) =>{
      if(type=='brand'){
        brandUpdateBtn.value = status
      }
      if(type=='product'){
        productUpdateBtn.value = status
      }
    }
    const setUpdateBtnStatus=status=>{
      updateBtnStatus.value=status
    }
    return {
      commissionConfig,
      getCommissionConfig,
      setUpdateBtnStatus,
      brandUpdateBtn,
      productUpdateBtn,
      setBtnStatus,
      programConfig,
      setProgramConfig,
      programConfigLink,
      setProgramConfigLink,
      pageType,
      setPageType,
      isAcc,
      setIsAcc
    }
  }
)
